import {
  alerter,
} from '@codev/helix-react';
import translate from './translate.js';

export default async function handleNetworkError(action, language = 'en_US') {
  try {
    await action();
  } catch (e) {
    if (e.message === 'Network Error') {
      alerter.alert({type: 'error', message: translate('networkError', language), suppressAlertType: true,});
    }
    throw e;
  }
}
